<div class="concurrency-changes-dialog_content">
  <p class="message">{{ message | transloco }}</p>
  @if (data.concurrencyChanges.type === ConcurrencyChangeType.Content) {
    <div>
      <p>{{ 'OverwriteChangesMessage' | transloco }}</p>
      <common-checkbox [(ngModel)]="isCheckboxSelected">{{ 'OverwriteChangesConfirmation' | transloco }}</common-checkbox>
    </div>
  }
</div>

@if (data.concurrencyChanges.type === ConcurrencyChangeType.Content) {
  <div class="concurrency-changes-dialog_actions">
    <button ttButton [emphasis]="'subtle'" [variant]="'secondary'" (click)="close(false)">{{ 'Cancel' | transloco }}</button>
    <button ttButton [disabled]="!isCheckboxSelected" [variant]="'destructive'" (click)="close(true)">
      {{ 'Confirm' | transloco }}
    </button>
  </div>
} @else {
  <div class="concurrency-changes-dialog_actions">
    <button ttButton [variant]="'primary'" (click)="close(false)">{{ 'Close' | transloco }}</button>
  </div>
}
